import { cva } from 'src/lib/cva'
import ComponentColor from 'src/types/ItemColor'

const componentColorVariants = cva('', {
  variants: {
    background: {
      [ComponentColor.orange]: 'bg-carrot-orange',
      [ComponentColor.blue]: 'bg-blue',
      [ComponentColor.purple]: 'bg-purple-500',
      [ComponentColor.darkBlue]: 'bg-jacksons-purple',
    },
    backgroundLight: {
      [ComponentColor.blue]: 'bg-porcelain',
      [ComponentColor.orange]: 'bg-serenade',
      [ComponentColor.purple]: 'bg-purple-100',
      [ComponentColor.darkBlue]: 'bg-titan-white',
    },
    tableRowBackground: {
      [ComponentColor.orange]: 'bg-white odd:bg-fantasy',
      [ComponentColor.blue]: 'bg-white odd:bg-black-squeeze',
      [ComponentColor.purple]: 'bg-white odd:bg-purple-50',
      [ComponentColor.darkBlue]: 'bg-white odd:bg-titan-white',
    },
    backgroundLightActive: {
      [ComponentColor.blue]: 'bg-[#29abe2]/10',
      [ComponentColor.orange]: 'bg-tequila',
      [ComponentColor.purple]: 'bg-purple-200',
      [ComponentColor.darkBlue]: 'bg-hawkes-blue',
    },
    border: {
      [ComponentColor.orange]: 'border-carrot-orange',
      [ComponentColor.blue]: 'border-blue',
      [ComponentColor.purple]: 'border-medium-purple',
      [ComponentColor.darkBlue]: 'border-jacksons-purple',
    },
    text: {
      [ComponentColor.orange]: 'text-carrot-orange',
      [ComponentColor.blue]: 'text-blue',
      [ComponentColor.purple]: 'text-medium-purple',
      [ComponentColor.darkBlue]: 'text-jacksons-purple',
    },
    textActive: {
      [ComponentColor.orange]: 'text-chelsea-gem',
      [ComponentColor.blue]: 'text-blue',
      [ComponentColor.purple]: 'text-medium-purple',
      [ComponentColor.darkBlue]: 'text-jacksons-purple',
    },
    textLight: {
      [ComponentColor.blue]: 'text-dove-gray',
      [ComponentColor.orange]: 'text-serenade',
      [ComponentColor.purple]: 'text-blue-chalk',
      [ComponentColor.darkBlue]: 'text-hawkes-blue',
    },
    textDropdownActive: {
      [ComponentColor.blue]: 'text-cod-gray',
      [ComponentColor.orange]: 'text-chelsea-gem',
      [ComponentColor.purple]: 'text-purple-700',
      [ComponentColor.darkBlue]: 'text-slightly-darker-blue',
    },
    textDark: {
      [ComponentColor.blue]: 'text-mine-shaft',
      [ComponentColor.orange]: 'text-ochre',
      [ComponentColor.purple]: 'text-medium-purple',
      [ComponentColor.darkBlue]: 'text-jacksons-purple',
    },
    textIcon: {
      [ComponentColor.blue]: 'text-gray-chateau',
      [ComponentColor.orange]: 'text-carrot-orange',
      [ComponentColor.purple]: 'text-purple-500',
      [ComponentColor.darkBlue]: 'text-jacksons-purple',
    },
    textIconActive: {
      [ComponentColor.blue]: 'text-mine-shaft',
      [ComponentColor.orange]: 'text-chelsea-gem',
      [ComponentColor.purple]: 'text-purple-700',
      [ComponentColor.darkBlue]: 'text-slightly-darker-blue',
    },
    rowHover: {
      [ComponentColor.orange]: 'bg-serenade',
      [ComponentColor.blue]: 'bg-curious-blue/10',
      [ComponentColor.purple]: 'bg-blue-chalk',
      [ComponentColor.darkBlue]: 'bg-titan-white',
    },
    rowHoverLight: {
      [ComponentColor.orange]: 'bg-bridal-heath',
      [ComponentColor.blue]: 'bg-foam',
      [ComponentColor.purple]: 'bg-medium-purple/10',
      [ComponentColor.darkBlue]: 'bg-jacksons-purple/10',
    },
    dropdownBorder: {
      [ComponentColor.orange]:
        'text-carrot-orange border-l-[2px] border-l-solid border-l-carrot-orange bg-hot-cinnamon/10',
      [ComponentColor.blue]:
        'text-blue border-l-[2px] border-l-solid border-l-blue bg-curious-blue/10',
      [ComponentColor.purple]:
        'text-medium-purple border-l-[2px] border-l-solid border-l-medium-purple bg-medium-purple/10',
      [ComponentColor.darkBlue]:
        'text-jacksons-purple border-l-[2px] border-l-solid border-l-jacksons-purple bg-jacksons-purple/10',
    },
    ring: {
      [ComponentColor.orange]: 'ring-carrot-orange',
      [ComponentColor.blue]: 'ring-blue',
      [ComponentColor.purple]: 'ring-medium-purple',
      [ComponentColor.darkBlue]: 'ring-jacksons-purple',
    },
  },
})

export default componentColorVariants
